import { render, staticRenderFns } from "./examArticle.vue?vue&type=template&id=741d7144&scoped=true&"
import script from "./examArticle.vue?vue&type=script&lang=js&"
export * from "./examArticle.vue?vue&type=script&lang=js&"
import style0 from "./examArticle.vue?vue&type=style&index=0&lang=css&"
import style1 from "./examArticle.vue?vue&type=style&index=1&id=741d7144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741d7144",
  null
  
)

export default component.exports